import React, { useEffect, useMemo, useState } from "react";

const InjAssessment = ({ apiData, onChange }: any) => {
  const [activeTab, setActiveTab] = useState("palpation");
  const [activeSpeed, setActiveSpeed] = useState("");

  const data = apiData || {};

  // ✅ STORE ALL VALUES HERE
  const [formDataState, setFormDataState] = useState<any>({
    dateofAssessment: "",
    palpation_right: "",
    palpation_left: "",
    rom: {},
    strength: {},
    special: {},
    isokinetic: {},
  });
  const [activeJoint, setActiveJoint] = useState(data.joints[0]?.joint_id);
  const [activePart, setActivePart] = useState(data.special_tests.body_parts[0]);

  const movementMap = useMemo(() => {
    const map: any = {};
    data.movements.forEach((m: any) => {
      if (!map[m.joint_id]) map[m.joint_id] = [];
      map[m.joint_id].push(m);
    });
    return map;
  }, [data.movements]);

  // ✅ COMMON UPDATE FUNCTION
  const updateState = (section: string, key: string, value: any) => {
    setFormDataState((prev: any) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: value,
      },
    }));
  };

  // ✅ SEND DATA TO PARENT
  useEffect(() => {
    const finalObj: any = {
      dateofAssessment: formDataState.dateofAssessment,
      palpation_right: formDataState.palpation_right,
      palpation_left: formDataState.palpation_left,

      rom: [],
      strength: [],
      special: [],
      isokinetic: [],
    };

    // ✅ ROM ARRAY
    const jointMap: any = {};
    (data.joints || []).forEach((j: any) => {
      jointMap[j.joint_id] = j.joint_name;
    });

    Object.entries(formDataState.rom).forEach(([key, val]: any) => {
      const [joint, movement] = key.split("_");

      finalObj.rom.push({
        joint_id: joint,
        joint_name: jointMap[joint],
        movement_name: movement,
        value: val,
      });
    });

    // ✅ STRENGTH ARRAY
    Object.entries(formDataState.strength).forEach(([key, val]: any) => {
      const [joint, position] = key.split("_");

      finalObj.strength.push({
        joint_id: joint,
        joint_name: jointMap[joint],
        position: position,
        observation: val,
      });
    });

    // ✅ SPECIAL ARRAY
    Object.entries(formDataState.special).forEach(([testId, val]: any) => {
      finalObj.special.push({
        body_part: activePart,
        test_id: testId,
        ...val, // contains val_1, val_2, remarks
      });
    });

    // ✅ ISOKINETIC ARRAY
    Object.entries(formDataState.isokinetic).forEach(([key, val]: any) => {
      const [speed, param] = key.split("_");

      finalObj.isokinetic.push({
        speed: speed,
        parameter: param,
        value: val,
      });
    });

    // ✅ FINAL OUTPUT
    onChange([finalObj]);

  }, [formDataState]);

  // ================= PALPATION =================
  const renderPalpation = () => {
    return (
      <div>
        <h5>Palpation</h5>

        <div className="row">

          <div className="col-lg-4">
            <label className="form-label">Date Of Assessment</label>
            <input
              type="date"
              className="form-control"
              required
              onChange={(e) =>
                setFormDataState((prev: any) => ({
                  ...prev,
                  dateofAssessment: e.target.value,
                }))
              }
              placeholder="Enter Date of Assessment" />
          </div>

          <div className="col-lg-4">
            <label>Right</label>
            <input
              className="form-control"
              onChange={(e) =>
                setFormDataState((prev: any) => ({
                  ...prev,
                  palpation_right: e.target.value,
                }))
              }
            />
          </div>

          <div className="col-lg-4">
            <label>Left</label>
            <input
              className="form-control"
              onChange={(e) =>
                setFormDataState((prev: any) => ({
                  ...prev,
                  palpation_left: e.target.value,
                }))
              }
            />
          </div>
        </div>
      </div>
    );
  };

  // ================= RANGE OF MOTION =================
  const renderROM = () => {
    const joints = data.joints || [];
    const movements = data.movements || [];

    return (
      <div>
        <h5>Range of Motion</h5>

        <div className="row">
          <div className="col-lg-4">
            <ul className="list-group">
              {joints.map((joint: any) => (
                <li
                  key={joint.joint_id}
                  className={`list-group-item ${activeJoint === joint.joint_id ? "active" : ""
                    }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => setActiveJoint(joint.joint_id)}
                >
                  {joint.joint_name}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-lg-5">
            <table className="table">
              <thead>
                <tr>
                  <th>Movement</th>
                  <th>Value</th>
                </tr>
              </thead>

              <tbody>
                {(movementMap[activeJoint] || []).map((move: any) => (
                  <tr key={move.movement_id}>
                    <td>{move.movement_name}</td>
                    <td>
                      <input
                        type="number"
                        className="form-control"
                        onChange={(e) =>
                          updateState(
                            "rom",
                            `${activeJoint}_${move.movement_name}`,
                            e.target.value
                          )
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* {joints.map((joint: any) => (
          <div key={joint.joint_id} className="mb-3">
            <h6>{joint.joint_name}</h6>

            {movements
              .filter((m: any) => m.joint_id === joint.joint_id)
              .map((m: any) => (
                <div key={m.movement_id} className="row mb-2">
                  <div className="col-lg-4">{m.movement_name}</div>

                  <div className="col-lg-4">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Right"
                      onChange={(e) =>
                        updateState(
                          "rom",
                          `${joint.joint_id}_${m.movement_id}_R`,
                          e.target.value
                        )
                      }
                    />
                  </div>

                  <div className="col-lg-4">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Left"
                      onChange={(e) =>
                        updateState(
                          "rom",
                          `${joint.joint_id}_${m.movement_id}_L`,
                          e.target.value
                        )
                      }
                    />
                  </div>
                </div>
              ))}
          </div>
        ))} */}
      </div>
    );
  };

  // ================= STRENGTH =================
  const renderStrength = () => {
    const strength = data.strength_observations || {};
    const joints = strength.joints || [];
    const positions = strength.positions || [];
    const lookup = strength.observations_lookup || {};

    return (
      <div>
        <h5>Strength Testing</h5>

        <div className="row">
          <div className="col-lg-4">
            <ul className="list-group">
              {joints.map((joint: any) => (
                <li
                  key={joint.joint_id}
                  className={`list-group-item ${activeJoint === joint.joint_id ? "active" : ""
                    }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => setActiveJoint(joint.joint_id)}
                >
                  {joint.joint_name}
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-8">
            {positions.map((pos: string) => (
              <div key={pos} className="row mb-2">
                <div className="col-lg-4">{pos}</div>

                <div className="col-lg-8">
                  <select
                    className="form-control"
                    onChange={(e) =>
                      updateState(
                        "strength",
                        `${activeJoint}_${pos}`,
                        e.target.value
                      )
                    }
                  >
                    <option>Select</option>
                    {(lookup[pos] || []).map((o: any) => (
                      <option key={o.id} value={o.text}>
                        {o.text}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* {joints.map((joint: any) => (
          <div key={joint.joint_id} className="mb-3">
            <h6>{joint.joint_name}</h6>

            {positions.map((pos: string) => (
              <div key={pos} className="row mb-2">
                <div className="col-lg-4">{pos}</div>

                <div className="col-lg-8">
                  <select
                    className="form-control"
                    onChange={(e) =>
                      updateState(
                        "strength",
                        `${joint.joint_id}_${pos}`,
                        e.target.value
                      )
                    }
                  >
                    <option>Select</option>
                    {(lookup[pos] || []).map((o: any) => (
                      <option key={o.id} value={o.id}>
                        {o.text}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            ))}
          </div>
        ))} */}
      </div>
    );
  };

  // ================= SPECIAL TEST =================
  const renderSpecial = () => {
    const sp = data.special_tests || {};
    const parts = sp.body_parts || [];
    const tests = sp.tests_by_part || {};

    return (
      <div>
        <h5>Special Tests</h5>

        <div className="row">
          {/* LEFT SIDE */}
          <div className="col-lg-3">
            <ul className="list-group">
              {parts.map((part: string) => (
                <li
                  key={part}
                  className={`list-group-item ${activePart === part ? "active" : ""
                    }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => setActivePart(part)}
                >
                  {part}
                </li>
              ))}
            </ul>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-9">
            <h6>{activePart}</h6>

            {(tests[activePart] || []).map((t: any) => (
              <div key={t.id} className="row mb-2">
                <div className="col-lg-6">{t.text}</div>

                {/* RIGHT */}
                <div className="col-lg-2">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Right"
                    onChange={(e) =>
                      updateState("special", t.id, {
                        ...(formDataState.special[t.id] || {}),
                        test_name: t.text,
                        val_1: e.target.value,
                      })
                    }
                  />
                </div>

                {/* LEFT */}
                <div className="col-lg-2">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Left"
                    onChange={(e) =>
                      updateState("special", t.id, {
                        ...(formDataState.special[t.id] || {}),
                        test_name: t.text,
                        val_2: e.target.value,
                      })
                    }
                  />
                </div>

                {/* REMARKS */}
                <div className="col-lg-2">
                  <input
                    className="form-control"
                    placeholder="Remarks"
                    onChange={(e) =>
                      updateState("special", t.id, {
                        ...(formDataState.special[t.id] || {}),
                        
                        remarks: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* {parts.map((part: string) => (
          <div key={part} className="mb-3">
            <h6>{part}</h6>

            {(tests[part] || []).map((t: any) => (
              <div key={t.id} className="row mb-2">
                <div className="col-lg-6">{t.text}</div>

                <div className="col-lg-2">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="R"
                    onChange={(e) =>
                      updateState("special", t.id, {
                        ...formDataState.special[t.id],
                        val_1: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="col-lg-2">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="L"
                    onChange={(e) =>
                      updateState("special", t.id, {
                        ...formDataState.special[t.id],
                        val_2: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="col-lg-2">
                  <input
                    className="form-control"
                    placeholder="Remarks"
                    onChange={(e) =>
                      updateState("special", t.id, {
                        ...formDataState.special[t.id],
                        remarks: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            ))}
          </div>
        ))} */}
      </div>
    );
  };

  // ================= ISOKINETIC =================
  const renderIsokinetic = () => {
    const iso = data.isokinetic || {};
    const speeds = iso.speeds || [];
    const params = iso.parameters || {};

    return (
      <div className="row">
        <div className="col-4">
          <ul className="list-group">
            {speeds.map((speed: string) => (
              <li
                key={speed}
                className={`list-group-item ${activeSpeed === speed ? "active" : ""
                  }`}
                style={{ cursor: "pointer" }}
                onClick={() => setActiveSpeed(speed)}
              >
                {speed}
              </li>
            ))}
          </ul>
        </div>

        <div className="col-8">
          <h6>{activeSpeed}</h6>

          {(params[activeSpeed] || []).map((p: any) => (
            <div key={p.id} className="row mb-2">
              <div className="col-lg-6">{p.text}</div>

              <div className="col-lg-6">
                <input
                  type="number"
                  className="form-control"
                  placeholder={`Enter value (${iso.unit || ""})`}
                  onChange={(e) =>
                    updateState(
                      "isokinetic",
                      `${activeSpeed}_${p.text}`,
                      e.target.value
                    )
                  }
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // ================= MAIN =================
  return (
    <div className="row">
      <div className="col-lg-3">
        <ul className="list-group">
          {[
            "palpation",
            "range_of_motion",
            "strength",
            "special",
            "isokinetic",
          ].map((item) => (
            <li
              key={item}
              className={`list-group-item ${activeTab === item ? "active" : ""
                }`}
              style={{ cursor: "pointer" }}
              onClick={() => setActiveTab(item)}
            >
              {item.replaceAll("_", " ").toUpperCase()}
            </li>
          ))}
        </ul>
      </div>

      <div className="col-lg-9">
        {activeTab === "palpation" && renderPalpation()}
        {activeTab === "range_of_motion" && renderROM()}
        {activeTab === "strength" && renderStrength()}
        {activeTab === "special" && renderSpecial()}
        {activeTab === "isokinetic" && renderIsokinetic()}
      </div>
    </div>
  );
};

export default InjAssessment;